import { render, staticRenderFns } from "./ControlProduct.vue?vue&type=template&id=747c11f3"
import script from "./ControlProduct.vue?vue&type=script&lang=js"
export * from "./ControlProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports